<template>
  <div
    class="custom-design"
    :class="{'custom-design--labels-bottom': labelsPosition === 'bottom',
    'custom-design--full': alwaysShowFullSpeaker,
    'custom-design--sideways': mobileOrientation === 'sideways',
    'custom-design--power-up': showPowerUp}"
  >
    <div
      class="canvas-wrapper"
      :class="{ 'canvas-wrapper--solo': showView === 'front' || showView === 'back' }"
    >
      <div
        v-if="showView === 'front' || showView === 'both'"
        class="canvas-container-wrap canvas-container-wrap--front"
        :class="{ 'canvas-container-wrap--show-both-front': emphasizedView === 'equal', 
        'canvas-container-wrap--emphasized': emphasizedView === 'front',
        'canvas-container-wrap--labels-bottom': labelsPosition === 'bottom',
          'canvas-container-wrap--no-label': !labels,
          'canvas-container-wrap--power-up': showPowerUp,
        'canvas-container-wrap--slide-in': emphasizedView === 'back' && slideTransition,
        'canvas-container-wrap--slide-in-running': activatePageTransition }"
      >
        <div
          class="hotspots"
          v-if="hotspots"
          :class="{ 'hotspots--top-label': labelsPosition === 'top', 'hotspots--bottom-label': labelsPosition === 'bottom'}"
        >
          <div class="hotspots-group">
            <router-link class="hotspot hotspot__fabric-front" :to="{ name: 'Fabric' }">
              <span class="sr-only">Configure fabric</span>
            </router-link>
          </div>
          <div class="hotspots-group">
            <router-link class="hotspot hotspot__icon" :to="{ name: 'Icon' }">
              <span class="sr-only">Configure icon</span>
            </router-link>
          </div>
          <div class="hotspots-group">
            <router-link class="hotspot hotspot__caps-top" :to="{ name: 'Caps' }">
              <span class="sr-only">Configure caps</span>
            </router-link>
            <router-link class="hotspot hotspot__caps-bottom" :to="{ name: 'Caps' }">
              <span class="sr-only">Configure caps</span>
            </router-link>
          </div>
        </div>
        <!-- TODO: add loader we can place over the canvas -->
        <canvas :id="'configFront' + suffix" class="canvas"></canvas>
      </div>
      <div
        v-if="showView === 'back' || showView === 'both'"
        class="canvas-container-wrap canvas-container-wrap--back"
        :class="{ 'canvas-container-wrap--show-both-back': emphasizedView === 'equal',
        'canvas-container-wrap--emphasized': emphasizedView === 'back',
        'canvas-container-wrap--labels-bottom': labelsPosition === 'bottom',
        'canvas-container-wrap--no-label': !labels,
        'canvas-container-wrap--power-up': showPowerUp,
        'canvas-container-wrap--slide-in': emphasizedView !== 'back' && slideTransition,
        'canvas-container-wrap--slide-in-running': activatePageTransition }"
      >
        <div
          class="hotspots"
          v-if="hotspots"
          :class="{ 'hotspots--top-label': labelsPosition === 'top', 'hotspots--bottom-label': labelsPosition === 'bottom'}"
        >
          <div class="hotspots-group hotspots-group--fabric-back">
            <router-link class="hotspot hotspot__fabric-back-left" :to="{ name: 'Fabric' }">
              <span class="sr-only">Configure fabric</span>
            </router-link>
            <router-link class="hotspot hotspot__fabric-back-right" :to="{ name: 'Fabric' }">
              <span class="sr-only">Configure fabric</span>
            </router-link>
          </div>
          <div class="hotspots-group">
            <router-link class="hotspot hotspot__spine" :to="{ name: 'Spine' }">
              <span class="sr-only">Configure spine</span>
            </router-link>
          </div>
          <div class="hotspots-group">
            <router-link class="hotspot hotspot__text" :to="{ name: 'CustomText' }">
              <span class="sr-only">Configure text</span>
            </router-link>
          </div>
          <div class="hotspots-group">
            <router-link class="hotspot hotspot__caps-top" :to="{ name: 'Caps' }">
              <span class="sr-only">Configure caps</span>
            </router-link>
            <router-link class="hotspot hotspot__caps-bottom" :to="{ name: 'Caps' }">
              <span class="sr-only">Configure caps</span>
            </router-link>
          </div>
          <div class="hotspots-group">
            <router-link class="hotspot hotspot__loop" :to="{ name: 'Loop' }">
              <span class="sr-only">Configure loop</span>
            </router-link>
          </div>
        </div>
        <!-- TODO: add loader we can place over the canvas -->
        <canvas :id="'configBack' + suffix" class="canvas"></canvas>
      </div>
    </div>
    <div class="hidden-canvases" style="display: none">
      <canvas height="522" width="200" :id="'saveFront' + suffix" class="save-front-canvas"></canvas>
      <canvas height="522" width="200" :id="'saveBack' + suffix" class="save-back-canvas"></canvas>
      <canvas height="400" width="288" :id="'merged' + suffix" class="merged-canvas"></canvas>
      <canvas height="1044" width="750" :id="'emailCanvas' + suffix" class="email-canvas"></canvas>
      <canvas height="1044" width="2088" :id="'socialCanvas' + suffix" class="social-canvas"></canvas>
    </div>
  </div>
</template>

<script>
import store from "../store.js";
import * as FontFaceObserver from "fontfaceobserver";
import { hexToRgb, lightOrDark } from "../helpers";
import FileSaver from "file-saver";
import * as canvasToBlob from "canvas-to-blob";
import { EventBus } from "../eventBus";

const font = new FontFaceObserver("News Gothic", {
  weight: 700
});

export default {
  props: {
    emphasizedView: {
      type: String,
      validator: function(value) {
        return ["front", "back", "equal"].indexOf(value) !== -1;
      }
    },
    slideTransition: {
      type: Boolean,
      default: false
    },
    // on mobile we may want the item oriented on its side instead of upright. on desktop, the item is ALWAYS upright.
    mobileOrientation: {
      type: String,
      default: "upright",
      validator: function(value) {
        return ["upright", "sideways"].indexOf(value) !== -1;
      }
    },
    alwaysShowFullSpeaker: {
      type: Boolean,
      default: false
    },
    showPowerUp: {
      type: Boolean,
      default: false
    },
    showView: {
      type: String,
      default: "both",
      validator: function(value) {
        return ["front", "back", "both"].indexOf(value) !== -1;
      }
    },
    hotspots: {
      type: Boolean,
      default: true
    },
    labels: {
      type: Boolean,
      default: true
    },
    labelsPosition: {
      type: String,
      default: "top",
      validator: function(value) {
        return ["top", "bottom"].indexOf(value) !== -1;
      }
    },
    suffix: {
      type: String,
      required: true
    },
    configToLoad: {
      type: Object
    }
  },
  data() {
    return {
      canvasWidth: 400,
      canvasHeight: 1044,
      canvas: null,
      // layers
      fabricFront: null,
      fabricBack: null,
      capsFront: null,
      capsBack: null,
      icon: null,
      spine: null,
      loop: null,
      logo: null,
      fontLoaded: false,
      customText: null,
      show: false,
      activatePageTransition: false
    };
  },
  mounted() {
    this.initFabric();
    this.initStoreWatchers();
    this.show = true;

    // TODO: this runs multiple times because we have multiple config-canvas elements on a page. how do we mitigate that?
    // TODO: maybe we can read showView and determine whether or not this component should listen for these events

    EventBus.$on("saveCanvasToDataURL", this.saveCanvasToDataURL);
    EventBus.$on("getThumbnailImage", () => {
      this.getThumbnailImage();
    });
    EventBus.$on("getEmailImage", () => {
      this.getEmailImage();
    });
    EventBus.$on("getSocialImage", () => {
      this.getSocialImage();
    });
    EventBus.$on("getFrontImage", () => {
      this.getFrontImage();
    });
    EventBus.$on("getBackImage", () => {
      this.getBackImage();
    });
  },
  watch: {
    configToLoad: function(newVal, oldVal) {

      if (Object.keys(this.configToLoad).length > 0) {
        this.clearCanvas();
        this.loadConfigFromParam();
      }
    }
  },
  methods: {
    saveCanvasToDataURL() {
      
    },
    getFrontImage() {
      const saveFrontCanvas = document
        .getElementById("saveFront" + this.suffix)
        .getContext("2d");
      const configFront = document.getElementById("configFront" + this.suffix);

      saveFrontCanvas.drawImage(
        configFront,
        0,
        0,
        document.getElementById("saveFront" + this.suffix).width,
        document.getElementById("saveFront" + this.suffix).height
      );
      EventBus.$emit(
        "frontDataURL",
        document
          .getElementById("saveFront" + this.suffix)
          .toDataURL({ format: "image/png" })
      );
    },
    getBackImage() {
      const saveBackCanvas = document
        .getElementById("saveBack" + this.suffix)
        .getContext("2d");
      const configBack = document.getElementById("configBack" + this.suffix);

      saveBackCanvas.drawImage(
        configBack,
        0,
        0,
        document.getElementById("saveBack" + this.suffix).width,
        document.getElementById("saveBack" + this.suffix).height
      );
      EventBus.$emit(
        "backDataURL",
        document
          .getElementById("saveBack" + this.suffix)
          .toDataURL({ format: "image/png" })
      );
    },
    getThumbnailImage() {
      console.log(this.suffix, 'getThumbnailImage suffix')
      const sharedCanvas = document
        .getElementById("merged" + this.suffix)
        .getContext("2d");
      const configFront = document.getElementById("configFront" + this.suffix);
      const configBack = document.getElementById("configBack" + this.suffix);
      // place configFront and configBack on shared so we can get an image with both
      sharedCanvas.drawImage(configBack, 0, 5, 153 * 0.975, 400 * 0.975);
      sharedCanvas.drawImage(configFront, 134, 0, 153, 400);

      // emit event for shared canvas url to the event bus
      EventBus.$emit(
        "thumbnailDataURL",
        document
          .getElementById("merged" + this.suffix)
          .toDataURL({ format: "image/png" })
      );
    },
    getEmailImage() {
      const emailCanvas = document.getElementById("emailCanvas" + this.suffix);
      const configFront = document.getElementById("configFront" + this.suffix);
      const configBack = document.getElementById("configBack" + this.suffix);

      emailCanvas.getContext("2d").drawImage(configBack, 0, 10, 390, 1015.95);
      emailCanvas.getContext("2d").drawImage(configFront, 350, 0, 400, 1044);

      EventBus.$emit(
        "emailDataURL",
        emailCanvas.toDataURL({ format: "image/png" })
      );
    },
    getSocialImage() {
      const socialCanvas = document.getElementById(
        "socialCanvas" + this.suffix
      );
      const configFront = document.getElementById("configFront" + this.suffix);
      const configBack = document.getElementById("configBack" + this.suffix);
      socialCanvas
        .getContext("2d")
        .clearRect(0, 0, socialCanvas.width, socialCanvas.height);

      socialCanvas
        .getContext("2d")
        .drawImage(configBack, 669, 10, 390, 1015.95);
      socialCanvas.getContext("2d").drawImage(configFront, 1019, 0, 400, 1044);

      EventBus.$emit(
        "socialDataURL",
        socialCanvas.toDataURL({ format: "image/jpeg" })
      );
    },
    getAverageRGB(image) {
      var blockSize = 5, // only visit every 5 pixels
        defaultRGB = { r: 0, g: 0, b: 0 }, // for non-supporting envs
        canvas = document.createElement("canvas"),
        context = canvas.getContext && canvas.getContext("2d"),
        data,
        width,
        height,
        i = -4,
        length,
        rgb = { r: 0, g: 0, b: 0 },
        count = 0;

      if (!context) {
        return defaultRGB;
      }

      height = canvas.height =
        imgEl.naturalHeight || imgEl.offsetHeight || imgEl.height;
      width = canvas.width =
        imgEl.naturalWidth || imgEl.offsetWidth || imgEl.width;

      context.drawImage(imgEl, 0, 0);

      try {
        data = context.getImageData(0, 0, width, height);
      } catch (e) {
        /* security error, img on diff domain */
        return defaultRGB;
      }

      length = data.data.length;

      while ((i += blockSize * 4) < length) {
        ++count;
        rgb.r += data.data[i];
        rgb.g += data.data[i + 1];
        rgb.b += data.data[i + 2];
      }

      // ~~ used to floor values
      rgb.r = ~~(rgb.r / count);
      rgb.g = ~~(rgb.g / count);
      rgb.b = ~~(rgb.b / count);

      return rgb;
    },
    initFabric() {
      var that = this;
      if (this.showView === "front") {
        that.initFront();
        if (
          that.showView === "front" &&
          (store.state.configuration.Fabric ||
            store.state.configuration.configId ||
            this.configToLoad)
        ) {
          that.loadConfiguration("canvasFront");
        } else {
          that.loadDefaults("canvasFront");
        }
      } else if (this.showView === "back") {
        that.initBack();
        if (
          that.showView === "back" &&
          (store.state.configuration.Fabric ||
            store.state.configuration.configId ||
            this.configToLoad)
        ) {
          that.loadConfiguration("canvasBack");
        } else {
          that.loadDefaults("canvasBack");
        }
      } else if (
        this.showView === "both" &&
        (store.state.configuration.Fabric ||
          store.state.configuration.configId ||
          this.configToLoad)
      ) {
        that.initFront();
        that.initBack();
        that.loadConfiguration();
      } else {
        that.initFront();
        that.initBack();
        that.loadDefaults();
      }
    },
    initAnimation() {
      const that = this;
      let animatingItems = document.querySelectorAll(
        ".canvas-container-wrap--slide-in"
      );
      setTimeout(function() {
        if (that.slideTransition) {
          that.activatePageTransition = true;
        }
      }, 200);
    },
    initFront() {
      this.canvasFront = new fabric.Canvas("configFront" + this.suffix, {
        width: this.canvasWidth,
        height: this.canvasHeight,
        backgroundColor: "rgba(255,255,255,0)",
        enableRetinaScaling: false,
        selection: false,
        preserveObjectStacking: true,
        allowTouchScrolling: true,
        containerClass: "canvas-container canvas-container--front"
      });
    },
    initBack() {
      this.canvasBack = new fabric.Canvas("configBack" + this.suffix, {
        width: this.canvasWidth,
        height: this.canvasHeight,
        backgroundColor: "rgba(255,255,255,0)",
        enableRetinaScaling: false,
        selection: false,
        preserveObjectStacking: true,
        allowTouchScrolling: true,
        containerClass: "canvas-container canvas-container--back"
      });
    },
    loadConfiguration(whichCanvas = "both") {
      var that = this;
      if (this.configToLoad) {
        this.loadConfigFromParam(whichCanvas);
      } else {
        this.loadConfigFromStore(whichCanvas);
      }
    },
    loadConfigFromStore(whichCanvas) {
      var that = this;
      if (whichCanvas === "canvasBack" || whichCanvas === "both") {
        that.setImage(
          that.getCloudinaryURL(store.state.productLogo),
          "canvasBack",
          "logo"
        );
        this.loadById(store.state.configuration.Spine, "canvasBack", "Spine");
        this.loadById(store.state.configuration.Loop, "canvasBack", "Loop");
        font.load().then(() => {
          that.fontLoaded = true;
          if (that.customText === null) {
            that.updateText(store.state.configuration.CustomText);
            if (that.canvasBack) {
              that.canvasBack.renderAll();
            }
          }
        });
      }
      if (whichCanvas === "canvasFront" || whichCanvas === "both") {
        this.loadById(store.state.configuration.Icon, "canvasFront", "Icon");
      }
      if (whichCanvas === "both") {
        // that.canvasFront && that.canvasBack
        this.loadById(store.state.configuration.Fabric, "both", "Fabric");
        this.loadById(store.state.configuration.Caps, "both", "Caps");
      } else {
        if (whichCanvas === "canvasFront") {
          //that.canvasFront
          this.loadById(
            store.state.configuration.Fabric,
            "canvasFront",
            "Fabric"
          );
          this.loadById(store.state.configuration.Caps, "canvasFront", "Caps");
        } else if (whichCanvas === "canvasBack") {
          // that.canvasBack
          this.loadById(
            store.state.configuration.Fabric,
            "canvasBack",
            "Fabric"
          );
          this.loadById(store.state.configuration.Caps, "canvasBack", "Caps");
        }
      }
      that.initAnimation();
    },
    loadConfigFromParam(whichCanvas = "both") {
      var that = this;
      if (that.configToLoad.Caps === "FL") {
        if (whichCanvas === "canvasFront" || whichCanvas === "both") {
          that.setImage(
            that.getCloudinaryURL(store.state.Defaults.Fabric.Front),
            "canvasFront",
            "fabricFront"
          );
          that.setImage(
            that.getCloudinaryURL(store.state.Defaults.Icons),
            "canvasFront",
            "icon"
          );
        }
        if (whichCanvas === "canvasBack" || whichCanvas === "both") {
          that.setImage(
            that.getCloudinaryURL(store.state.Defaults.Fabric.Back),
            "canvasBack",
            "fabricBack"
          );
          that.setImage(
            that.getCloudinaryURL(store.state.Defaults.Loop),
            "canvasBack",
            "loop"
          );
          that.setImage(
            that.getCloudinaryURL(store.state.Defaults.Spine),
            "canvasBack",
            "spine"
          );
          that.setImage(
            that.getCloudinaryURL(store.state.productLogo),
            "canvasBack",
            "logo"
          );
          font.load().then(() => {
            that.fontLoaded = true;
            if (that.customText === null) {
              that.updateText(store.state.configuration.CustomText);
              if (that.canvasBack) {
                that.canvasBack.renderAll();
              }
            }
          });
        }
        that.setImage("/images/right.png", "canvasFront", "capsFront");
        that.setImage("/images/left.png", "canvasBack", "capsBack");
      } else {
        if (whichCanvas === "canvasBack" || whichCanvas === "both") {
          that.setImage(
            that.getCloudinaryURL(store.state.productLogo),
            "canvasBack",
            "logo"
          );
          this.loadById(that.configToLoad.Spine, "canvasBack", "Spine");
          this.loadById(that.configToLoad.Loop, "canvasBack", "Loop");
          font.load().then(() => {
            that.fontLoaded = true;
            if (that.customText === null) {
              that.updateText(store.state.configuration.CustomText);
              if (that.canvasBack) {
                that.canvasBack.renderAll();
              }
            }
          });
        }
        if (whichCanvas === "canvasFront" || whichCanvas === "both") {
          this.loadById(that.configToLoad.Icon, "canvasFront", "Icon");
        }
        if (whichCanvas === "both") {
          // that.canvasFront && that.canvasBack
          this.loadById(that.configToLoad.Fabric, "both", "Fabric");
          this.loadById(that.configToLoad.Caps, "both", "Caps");
        } else {
          if (whichCanvas === "canvasFront") {
            //that.canvasFront
            this.loadById(that.configToLoad.Fabric, "canvasFront", "Fabric");
            this.loadById(that.configToLoad.Caps, "canvasFront", "Caps");
          } else if (whichCanvas === "canvasBack") {
            // that.canvasBack
            this.loadById(that.configToLoad.Fabric, "canvasBack", "Fabric");
            this.loadById(that.configToLoad.Caps, "canvasBack", "Caps");
          }
        }
      }
      that.initAnimation();
    },
    loadById(id, canvas, layer) {
      const that = this;
      const option = that.getOptionById(id, layer);
      const frontPart = { ...option.Images.Front };
      const backPart = { ...option.Images.Back };
      const urlFront = that.getCloudinaryURL(frontPart);
      const urlBack = that.getCloudinaryURL(backPart);
      if (canvas === "canvasBack" || canvas === "canvasFront") {
        if (
          layer.toLowerCase() === "caps" ||
          layer.toLowerCase() === "fabric"
        ) {
          if (canvas === "canvasFront") {
            that.setImage(urlFront, canvas, layer.toLowerCase() + "Front");
          } else {
            that.setImage(urlBack, canvas, layer.toLowerCase() + "Back");
          }
        } else {
          that.setImage(urlFront, canvas, layer.toLowerCase());
        }
      } else if (canvas === "both") {
        that.setImage(urlFront, "canvasFront", layer.toLowerCase() + "Front");
        that.setImage(urlBack, "canvasBack", layer.toLowerCase() + "Back");
      }
    },
    loadDefaults(whichCanvas = "both") {
      var that = this;
      if (whichCanvas === "canvasFront" || whichCanvas === "both") {
        that.setImage(
          that.getCloudinaryURL(store.state.Defaults.Fabric.Front),
          "canvasFront",
          "fabricFront"
        );
        that.setImage(
          that.getCloudinaryURL(store.state.Defaults.Caps.Front),
          "canvasFront",
          "capsFront"
        );
        that.setImage(
          that.getCloudinaryURL(store.state.Defaults.Icons),
          "canvasFront",
          "icon"
        );
      }
      if (whichCanvas === "canvasBack" || whichCanvas === "both") {
        that.setImage(
          that.getCloudinaryURL(store.state.Defaults.Fabric.Back),
          "canvasBack",
          "fabricBack"
        );
        that.setImage(
          that.getCloudinaryURL(store.state.Defaults.Caps.Back),
          "canvasBack",
          "capsBack"
        );
        that.setImage(
          that.getCloudinaryURL(store.state.Defaults.Loop),
          "canvasBack",
          "loop"
        );
        that.setImage(
          that.getCloudinaryURL(store.state.Defaults.Spine),
          "canvasBack",
          "spine"
        );
        that.setImage(
          that.getCloudinaryURL(store.state.productLogo),
          "canvasBack",
          "logo"
        );
        font.load().then(() => {
          that.fontLoaded = true;
          if (that.customText === null) {
            that.updateText(store.state.configuration.CustomText);
            if (that.canvasBack) {
              that.canvasBack.renderAll();
            }
          }
        });
      }
      that.initAnimation();
    },
    getCloudinaryURL(
      { CD_BasePath, CD_Version, CD_PublicId, CD_Format, Filename },
      optionsString = "w_400,h_1044,f_auto,q_auto:low"
    ) {
      // LATER: take in options
      return (
        CD_BasePath +
        "/" +
        optionsString +
        "/" +
        CD_Version +
        "/" +
        CD_PublicId +
        "." +
        CD_Format
      );
    },
    initStoreWatchers() {
      const that = this;
      // LATER: maybe we can consolidate these into less pieces

      store.watch(
        state => state.configuration.Fabric,
        (newVal, oldVal) => {
          if (newVal !== null) {
            const option = that.getOptionById(newVal, "Fabric");
            const imageFrontParts = { ...option.Images.Front };
            const imageBackParts = { ...option.Images.Back };
            const urlFront = that.getCloudinaryURL(imageFrontParts);
            const urlBack = that.getCloudinaryURL(imageBackParts);
            if (that.canvasFront) {
              that.setImage(urlFront, "canvasFront", "fabricFront");
            }
            if (that.canvasBack) {
              that.setImage(urlBack, "canvasBack", "fabricBack");
            }
          } else {
            // load default
            if (that.canvasFront) {
              that.setImage(
                that.getCloudinaryURL(store.state.Defaults.Fabric.Front),
                "canvasFront",
                "fabricFront"
              );
            }
            if (that.canvasBack) {
              that.setImage(
                that.getCloudinaryURL(store.state.Defaults.Fabric.Back),
                "canvasBack",
                "fabricBack"
              );
            }
          }
        }
      );

      store.watch(
        state => state.configuration.Caps,
        (newVal, oldVal) => {
          if (newVal !== null) {
            const option = that.getOptionById(newVal, "Caps");
            const imageFrontParts = { ...option.Images.Front };
            const imageBackParts = { ...option.Images.Back };
            const urlFront = that.getCloudinaryURL(imageFrontParts);
            const urlBack = that.getCloudinaryURL(imageBackParts);
            if (that.canvasFront) {
              that.setImage(urlFront, "canvasFront", "capsFront");
            }
            if (that.canvasBack) {
              that.setImage(urlBack, "canvasBack", "capsBack");
            }
          } else {
            // load default
            if (that.canvasFront) {
              that.setImage(
                that.getCloudinaryURL(store.state.Defaults.Caps.Front),
                "canvasFront",
                "capsFront"
              );
            }
            if (that.canvasBack) {
              that.setImage(
                that.getCloudinaryURL(store.state.Defaults.Caps.Back),
                "canvasBack",
                "capsBack"
              );
            }
          }
        }
      );

      store.watch(
        state => state.configuration.Icon,
        (newVal, oldVal) => {
          if (newVal !== null) {
            const option = that.getOptionById(newVal, "Icon");
            const imageFrontParts = { ...option.Images.Front };
            const urlFront = that.getCloudinaryURL(imageFrontParts);
            if (that.canvasFront) {
              that.setImage(urlFront, "canvasFront", "icon");
            }
          } else {
            // load default
            if (that.canvasFront) {
              that.setImage(
                that.getCloudinaryURL(store.state.Defaults.Icons),
                "canvasFront",
                "icon"
              );
            }
          }
        }
      );

      store.watch(
        state => state.configuration.Spine,
        (newVal, oldVal) => {
          if (newVal !== null) {
            const option = that.getOptionById(newVal, "Spine");
            const imageFrontParts = { ...option.Images.Front };
            const urlFront = that.getCloudinaryURL(imageFrontParts);
            if (that.canvasBack) {
              that.setImage(urlFront, "canvasBack", "spine");
            }
            if (that.fontLoaded) {
              that.updateText(store.state.configuration.CustomText);
              if (that.canvasBack) {
                that.canvasBack.renderAll();
              }
            } else {
              font.load().then(() => {
                that.fontLoaded = true;
                if (that.customText === null) {
                  that.updateText(store.state.configuration.CustomText);
                  if (that.canvasBack) {
                    that.canvasBack.renderAll();
                  }
                }
              });
            }
          } else {
            // load default
            if (that.canvasBack) {
              that.setImage(
                that.getCloudinaryURL(store.state.Defaults.Spine),
                "canvasBack",
                "spine"
              );
              that.updateText(store.state.configuration.CustomText);
            }
          }
        }
      );

      store.watch(
        state => state.configuration.Loop,
        (newVal, oldVal) => {
          if (newVal !== null) {
            const option = that.getOptionById(newVal, "Loop");
            const imageFrontParts = { ...option.Images.Front };
            const urlFront = that.getCloudinaryURL(imageFrontParts);
            if (that.canvasBack) {
              that.setImage(urlFront, "canvasBack", "loop");
            }
          } else {
            // load default
            if (that.canvasBack) {
              that.setImage(
                that.getCloudinaryURL(store.state.Defaults.Loop),
                "canvasBack",
                "loop"
              );
            }
          }
        }
      );

      store.watch(
        state => state.configuration.CustomText,
        (newVal, oldVal) => {
          if (newVal !== null) {
            font.load().then(() => {
              that.fontLoaded = true;
              this.updateText(newVal);
            });
          }
        }
      );
    },
    setImage(imageURL, whichCanvas, layer, selectable = false) {
      const that = this;
      // TODO: add loading indicator to the relevant canvas\
      fabric.Image.fromURL(
        imageURL,
        function(img) {
          that.removeImage(layer, whichCanvas, false);
          that[layer] = img.set(
            {
              left: 0,
              top: 0,
              selectable,
              evented: true,
              scaleX: 1,
              scaleY: 1
            },
            { crossOrigin: "anonymous" }
          );
          that[whichCanvas].add(that[layer]);
          that[whichCanvas].renderAll();
          that.resetZIndex();
        },
        { crossOrigin: "anonymous" }
      );
    },
    clearCanvas(removeData = false) {
      this.removeImage("customText", "both", removeData);
      this.removeImage("Caps", "both", removeData);
      this.removeImage("Fabric", "both", removeData);
      this.removeImage("Icon", "both", removeData);
      this.removeImage("Spine", "both", removeData);
      this.removeImage("Loop", "both", removeData);
    },
    removeImage(layer, whichCanvas, removeData = true) {
      if (this[whichCanvas]) {
        this[whichCanvas].remove(this[layer]);
        if (removeData) {
          this[layer] = null;
        }
      }
    },
    getTextColor(spineColor) {
      let lightness = lightOrDark(spineColor);
      let textGradient;

      if (lightness === "light") {
        textGradient = {
          0: "rgba(0,0,0,0.05)",
          1: "rgba(100,100,100,0.05)"
        };
      } else if (lightness === "dark") {
        // dark color
        textGradient = {
          0: "rgba(20,20,20,0.05)",
          1: "rgba(0,0,0,0.05)"
        };
      } else if (lightness === "darker") {
        // really dark
        textGradient = {
          0: "rgba(255,255,255,0.1)",
          1: "rgba(100,100,100,0.1)"
        };
      }
      return textGradient;
    },
    getStrokeColor(spineColor) {
      let lightness = lightOrDark(spineColor);
      let strokeColor;

      if (lightness === "light") {
        strokeColor = "rgba(0,0,0,0.2)";
      }
      if (lightness === "dark") {
        // dark color
        strokeColor = "rgba(30,30,30,0.4)";
      }
      if (lightness === "darker") {
        // darkest
        strokeColor = "rgba(30,30,30,0.7)";
      }
      return strokeColor;
    },
    fontToUse() {
      // test for non roman characters - from https://stackoverflow.com/questions/24107993/how-to-detect-non-roman-characters-in-js
      const usesNonRoman = /[^\u0000-\u024F\u1E00-\u1EFF\u2C60-\u2C7F\uA720-\uA7FF]/g.test(
        store.state.configuration.CustomText || store.state.defaultText
      );
      if (usesNonRoman) {
        store.commit("setFontToUse", "Noto Sans CJK SC Bold");
        return "noto";
      } else {
        store.commit("setFontToUse", "News Gothic Std");
        return "news gothic";
      }
    },
    getCloudinaryTextImageURL(spine, text = store.state.defaultText) {
      return `https://res.cloudinary.com/publish-prod/image/upload/l_text:Noto%20Sans_35_bold:${encodeURIComponent(
        encodeURIComponent(text)
      )},fl_cutter,a_90/v1553296357/configurator/${spine ||
        "default"}-mask.png`;
    },
    getTextData(spine) {
      const that = this;
      let textData = {
        spineColor: null,
        textGradient: null,
        strokeColor: null
      };
      if (spine) {
        textData.spineColor = hexToRgb(
          this.getOptionById(spine, "Spine").MainColor
        );
      } else {
        textData.spineColor = hexToRgb(store.state.Defaults.Spine.MainColor);
      }
      if (textData.spineColor) {
        // (if undefined, this is on WHITE)
        textData.spineColor = `rgba(${textData.spineColor.r},${
          textData.spineColor.g
        },${textData.spineColor.b},0.2)`;
      } else {
        textData.spineColor = `rgba(255,255,255,0.2)`;
      }
      textData.textGradient = that.getTextColor(textData.spineColor);
      textData.strokeColor = that.getStrokeColor(textData.spineColor);
      return textData;
    },
    updateText(text, selectable = false) {
      const that = this;
      if (text === null || typeof text === "undefined") {
        text = store.state.defaultText;
      }
      if (that.canvasBack) {
        let spine = store.state.configuration.Spine;
        that.removeImage("customText", "canvasBack", true);
        // that.canvasBack.remove(that.customText);

        if (that.fontToUse() === "noto") {
          const imageURL = that.getCloudinaryTextImageURL(
            spine,
            store.state.configuration.CustomText
          );
          // apply the image
          fabric.Image.fromURL(
            imageURL,
            function(img) {
              that.customText = img.set(
                {
                  left: 180,
                  top: 285,
                  selectable,
                  evented: true,
                  scaleX: 1,
                  scaleY: 1
                },
                { crossOrigin: "anonymous" }
              );

              that.canvasBack.add(that.customText);
              that.customText.centerV();
              that.customText.set("top", that.customText.aCoords.tl.y + 50);
              that.canvasBack.renderAll();
            },
            { crossOrigin: "anonymous" }
          );
        } else {
          const textData = that.getTextData(spine);
          // apply the text
          that.customText = new fabric.Text(text, {
            left: 220,
            top: 295,
            //fill: "rgba(0,0,0,0.15)",
            stroke: textData.strokeColor,
            strokeWidth: 0.75,
            fontFamily: "News Gothic",
            fontSize: 40,
            fontWeight: "bold",
            angle: 90,
            textAlign: "center",
            selectable,
            evented: false
          });
          that.customText.setGradient("fill", {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: that.customText.height,
            colorStops: textData.textGradient
          });
          that.canvasBack.add(that.customText);
          that.customText.centerV();

          // need to position text at a 50px offset from the center
          that.customText.set("top", that.customText.aCoords.tl.y + 50);

          that.customText.setCoords();
          that.canvasBack.renderAll();
        }
      }
    },
    resetZIndex() {
      if (this.fabricFront) {
        this.fabricFront.bringToFront();
      }
      if (this.fabricBack) {
        this.fabricBack.bringToFront();
      }
      if (this.icon) {
        this.icon.bringToFront();
      }
      if (this.spine) {
        this.spine.bringToFront();
      }
      if (this.capsFront) {
        this.capsFront.bringToFront();
      }
      if (this.capsBack) {
        this.capsBack.bringToFront();
      }
      if (this.loop) {
        this.loop.bringToFront();
      }

      if (this.logo) {
        this.logo.bringToFront();
      }

      if (this.customText) {
        this.customText.bringToFront();
      }
    },
    getOptionById(id, layer) {
      const filtered = store.state.productOptions[layer].Options.filter(
        option => option.Id === id
      );
      return filtered[0];
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../scss/_variables.scss";

.custom-design {
  // padding-top: 2em;
  height: 100%;
  box-sizing: border-box;
  width: 100%;
  // padding-left: 2em; // remove?
  // padding-right: 2em; // remove?
  display: flex;
  align-items: center;
  &--labels-bottom {
    padding-top: 0;
    // padding-bottom: 2em; // do we need this
  }
  &--sideways {
    // this is inside .random-speaker--text which is height 0

    @media (max-width: 991px) {
      position: absolute;
      padding: 0;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      .canvas-container-wrap--front {
        display: none;
      }
      .canvas-wrapper {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        justify-content: flex-start;
      }
      .canvas-container-wrap--back {
        transform: rotate(-90deg) translateX(-100%);
        transform-origin: 0 0;
        margin: 0;

        top: 0;
        left: 0;
        position: static;
        &:before {
          display: none;
        }
      }
    }
  }
  @media (min-width: 992px) {
    // height: calc(100vh - 170px - 60px); //725px; // 600px;
    /* we do not want a height set on /feeling-lucky/10/text */
    /* we DO want a height set on /configure/fabric, unless there's an alternative? */
    // overflow: hidden;
    align-self: center;
    display: flex;
    padding-top: 0;
    align-items: flex-start;
    &--full {
      height: auto;
      align-items: center;
    }
    @media (max-aspect-ratio: 1/1) {
      align-items: center;
    }
    @media (min-height: 1200px) {
      align-items: center;
    }
  }
}

.canvas-wrapper {
  position: relative;
  width: 100%;
  padding-bottom: 0;
  display: flex;
  justify-content: center;
  @media (min-width: 992px) {
    padding-bottom: calc(130% + 2em);
    @media (min-height: 1200px) {
      padding-bottom: 0;
    }
  }
  &--solo {
    padding-bottom: 0;
    .canvas-container-wrap--front {
      margin-left: 0;
    }
  }
}

.hotspots {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  &--top-label {
    top: 20px;
  }
  &--bottom-label {
  }
}

.hotspot {
  // TODO: fix the math for these hotspots so they are legit percentages
  &__fabric-front {
    // background: rgba(255,0,255,0.5);
    position: absolute;
    top: 2.5%;
    bottom: 3%;
    right: 0;
    left: 0;
    clip-path: polygon(
      0 2.8%,
      10% 1.5%,
      30% 0.8%,
      50% 0.5%,
      70% 0.8%,
      90% 1.5%,
      100% 2.7%,
      100% 98%,
      90% 99%,
      70% 100%,
      50% 100%,
      30% 100%,
      10% 99%,
      0 98%
    );
  }
  &__fabric-back-left {
    // background: rgba(255,0,255,0.5);
    position: absolute;
    top: 2.5%;
    bottom: 3%;
    right: 63%;
    left: 0;
    clip-path: polygon(
      0 2.8%,
      20% 1.5%,
      60% 0.8%,
      100% 0.5%,
      100% 100%,
      60% 100%,
      20% 99%,
      0 98%
    );
  }
  &__fabric-back-right {
    // background: rgba(255,0,255,0.5);
    position: absolute;
    top: 2.5%;
    bottom: 3%;
    right: 0;
    left: 63%;
    clip-path: polygon(
      0 0.5%,
      20% 0.5%,
      60% 1.25%,
      100% 2.5%,
      100% 98%,
      60% 99.5%,
      20% 100%,
      0 100%
    );
  }
  &__icon {
    position: absolute;
    top: 9.75%;
    bottom: 38.8%;
    right: 19.6%;
    left: 18.7%;
    clip-path: polygon(
      0 21%,
      45% 20%,
      45% 0,
      55% 0,
      55% 20%,
      100% 21%,
      100% 25.6%,
      55% 25%,
      55% 40%,
      55% 40%,
      55% 46%,
      50% 46%,
      50% 51%,
      50% 54.5%,
      55% 54.5%,
      55% 100%,
      45% 100%,
      45% 54.5%,
      50% 54.5%,
      50% 46%,
      45% 46%,
      45% 25%,
      0% 25.6%
    );
  }
  &__icon-vertical {
    // background: rgba(255,0,0,0.5);
    position: absolute;
    top: calc(1em + 9%);
    bottom: 37%;
    right: 46.5%;
    left: 46.5%;
  }
  &__icon-horizontal {
    position: absolute;
    top: calc(1em + 19%);
    bottom: 74%;
    right: 20%;
    left: 20%;
  }
  &__spine {
    position: absolute;
    top: 8.5%;
    bottom: 2.5%;
    right: 37%;
    left: 36.5%;
  }
  &__text {
    position: absolute;
    top: 35%;
    bottom: calc(20px + 22.5%);
    right: 45%;
    left: 45%;
  }
  &__loop {
    position: absolute;
    top: 1.5%;
    bottom: 91%;
    right: 37%;
    left: 36%;
    clip-path: polygon(
      0 5%,
      5% 0,
      95% 0,
      100% 5%,
      100% 97%,
      95% 100%,
      5% 100%,
      0 95%
    );
  }
  &__caps-top {
    position: absolute;
    top: 0;
    bottom: 95%;
    right: 0;
    left: 0;
    clip-path: polygon(
      0.5% 62%,
      2% 45%,
      4% 35%,
      5% 30%,
      10% 20%,
      20% 10%,
      30% 5%,
      50% 0,
      70% 5%,
      80% 10%,
      88% 18%,
      94% 30%,
      97% 40%,
      99.5% 59%,
      99.75% 75%,
      100% 100%,
      95% 85%,
      90% 80%,
      80% 70%,
      50% 60%,
      30% 65%,
      20% 70%,
      10% 80%,
      5% 85%,
      0 100%
    );

    .canvas-container-wrap--back & {
      clip-path: polygon(
        0.5% 62%,
        2% 45%,
        4% 35%,
        5% 30%,
        10% 20%,
        20% 10%,
        30% 5%,
        50% 0,
        70% 5%,
        80% 10%,
        90% 18%,
        95% 30%,
        97% 40%,
        99.5% 59%,
        99.75% 75%,
        100% 100%,
        95% 85%,
        90% 80%,
        80% 70%,
        63% 65%,
        63% 34%,
        61% 33%,
        37% 34%,
        36% 65%,
        30% 65%,
        20% 70%,
        10% 80%,
        5% 85%,
        0 100%
      );
    }
  }
  &__caps-bottom {
    position: absolute;
    top: 95%;
    bottom: 0;
    right: 0;
    left: 0;
    clip-path: polygon(
      0 0,
      5% 15%,
      10% 20%,
      20% 30%,
      30% 35%,
      50% 40%,
      80% 32%,
      90% 20%,
      95% 15%,
      100% 0,
      99% 60%,
      95% 75%,
      90% 82%,
      80% 90%,
      70% 95%,
      50% 100%,
      30% 95%,
      20% 90%,
      10% 82%,
      5% 75%,
      2% 66%,
      0 38%
    );
  }
}
.hotspots-group {
  @media (min-width: 992px) {
    a {
      background-color: rgba(0, 0, 0, 0);
      transition: background-color 0.25s;
    }
  }

  &:active,
  &:hover {
    a {
      background-color: rgba(0, 0, 0, 0.25) !important;
      // background-color: rgba(0, 0, 0, 0.05) !important;
    }
  }
  @media (min-width: 992px) {
    &:hover {
      a {
        background-color: rgba(0, 0, 0, 0.25) !important;
        // background-color: rgba(0, 0, 0, 0.05) !important;
      }
    }
  }
}
.canvas-container-wrap {
  width: 50%;
  //max-width: 235px;
  position: relative;
  @media (min-width: 992px) {
    // transform: translate3d(120px, 80px, 0);
    right: 60%;
    top: 50%;
    transform: translateY(calc(-50% - 1em));
    width: 37%; // 45
    max-width: none;
    position: absolute;
    @media (min-height: 900px) {
      // top: 12vh;
    }
    &.canvas-container-wrap--emphasized {
      // width: 100%;
      // max-width: 65%;
      width: 65%;
      transform: translateX(0) translateY(-50%);
      top: 65%;
      right: 0;
      @media (min-height: 900px) {
        top: 0;
        transform: translateX(0) translateY(0);
      }
      @media (min-height: 1200px) {
        top: 0;
        transform: translateX(0) translateY(-50%);
      }
    }
  }

  &:before {
    display: block;
    text-transform: uppercase;
    text-align: center;
    color: $greyMidDark;
    margin-bottom: 1em;
    line-height: 1;
    font-size: 10px;
  }
  &--front {
    // right: 15px;
    // z-index: 1;
    @media (max-width: 991px) {
      order: 1;
      z-index: 1;
      margin-left: -5%;
    }
    &:before {
      content: "Front";
    }
    &.canvas-container-wrap--no-label {
      &:before {
        content: none;
      }
    }
    &.canvas-container-wrap--labels-bottom {
      &:before {
        top: auto;
        bottom: -1.5rem;
        left: 50%;
        transform: translateX(-50%);
        margin-bottom: 0;
        position: absolute;
      }
    }
  }
  &--back {
    // left: 15px;
    @media (max-width: 991px) {
      order: 0;
      transform: scale(0.975);
    }
    &:before {
      content: "Back";
    }
    &.canvas-container-wrap--no-label {
      &:before {
        content: none;
      }
    }
    &.canvas-container-wrap--labels-bottom {
      &:before {
        top: auto;
        bottom: -1.5rem;
        left: 50%;
        transform: translateX(-50%);
        margin-bottom: 0;
        position: absolute;
      }
    }
  }
  &--emphasized {
    @media (min-width: 992px) {
      right: 0;
      left: auto;
      z-index: 2;
      max-width: 500px;
      transform: translate3d(0, 0, 0);
    }
  }
  &--show-both-front {
    right: 0;
    top: 0;
    width: 50%;
    transform: translate3d(0, 0, 0);
    z-index: 1;
    @media (min-width: 992px) {
      right: 15px;
    }
  }
  &--show-both-back {
    left: 1%;
    top: 0;
    width: 50%;
    transform: translate3d(0, 0, 0) scale(0.975);
    @media (min-width: 992px) {
      left: 15px;
    }
  }
  &--slide-in {
    @media (min-width: 992px) {
      transform: translateX(50px) translateY(-50%);
      opacity: 0;

      &-running {
        transform: translateX(0) translateY(-50%);
        opacity: 1;
        transition: all 0.5s;
      }
      &-completed {
        transition: none !important;
      }
    }
  }
  .canvas-wrapper--solo & {
    transform: none;
    height: auto;
    position: relative;
    left: auto;
    right: auto;
    .custom-design--full & {
      @media (min-width: 992px) {
        height: 0;
        padding-bottom: calc(100% + 3em);
      }
    }
    .custom-design--full & {
      &.canvas-container-wrap--power-up {
        padding-bottom: 2.75em;
        @media (min-width: 320px) {
          padding-bottom: 3.5em;
        }
        @media (min-width: 400px) {
          padding-bottom: 4em;
        }
        &:after {
          content: "";
          position: absolute;
          left: -3em;
          right: -3em;
          bottom: 0;
          background: transparent url("/images/power-up.png") center top
            no-repeat;
          background-size: contain;
          height: 0;
          padding-bottom: 33.75%;
          z-index: -1;
        }
        @media (min-width: 992px) {
          padding-bottom: calc(100% + 6em);
          &:after {
            bottom: 3.1em;
          }
        }
        @media (min-width: 1100px) {
          padding-bottom: calc(100% + 7em);
        }
      }
    }
  }
}

.backslide-enter-active {
  transition: all 0.5s;
  .canvas-container-wrap--back {
    transition: opacity 0.5s, transform 0.5s;
  }
}
.backslide-enter,
.backslide-leave-to {
  opacity: 0;
  .canvas-container-wrap--back {
    opacity: 0;
    transform: translateX(50px);
  }
}

// .canvas-container class is on the main App.vue component since it is not within this component (initialized by fabric.js)
</style>